var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"d-flex justify-center"},[_c('h2',[_vm._v(_vm._s(_vm.msg))])]),(_vm.haveParts)?_c('v-row',[_c('PartNumbers',{attrs:{"parts":_vm.matching,"api-base":_vm.apiBase}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }